<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="动作时间">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                :show-time="true"
                @change="onDateChange"
                date-format="YYYY-MM-DD HH:mm:ss"
              ></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="事件测点">
              <a-input placeholder="请输入事件测点" v-debounce="searchQuery" v-model="queryParam.pointCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="动作说明">
              <a-input placeholder="请输入动作说明" v-debounce="searchQuery" v-model="queryParam.eventDesc"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('动作事件日志')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a :disabled="!record.pointCode" @click="dataLine(record)">数据曲线</a>
        </span>
      </a-table>
    </div>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
    <iot-event-log-modal @ok="modalFormOk" ref="modalForm"></iot-event-log-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import IotEventLogModal from './modules/IotEventLogModal'
import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
import moment from 'dayjs'

export default {
  name: 'IotEventLogList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    PointsLineChartModal,
    IotEventLogModal
  },
  data() {
    return {
      description: '动作事件日志管理页面',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      isorter: {
        column: 'eventTime',
        order: 'desc'
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '动作时间',
          align: 'center',
          sorter: true,
          dataIndex: 'eventTime'
        },
        {
          title: '动作说明',
          align: 'center',
          sorter: true,
          dataIndex: 'eventDesc'
        },
        {
          title: '事件测点',
          align: 'center',
          sorter: true,
          dataIndex: 'pointCode'
        },
        {
          title: '上次值',
          align: 'center',
          sorter: true,
          dataIndex: 'lastVal'
        },
        {
          title: '当前值',
          align: 'center',
          sorter: true,
          dataIndex: 'currentVal'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/event/iotEventLog/list',
        delete: '/event/iotEventLog/delete',
        deleteBatch: '/event/iotEventLog/deleteBatch',
        exportXlsUrl: '/event/iotEventLog/exportXls',
        importExcelUrl: 'event/iotEventLog/importExcel'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() // 查询条件
      if (params.pointCode) {
        params.pointCode = `*${params.pointCode}*`
      }
      if (params.eventDesc) {
        params.eventDesc = `*${params.eventDesc}*`
      }
      this.loading = true
      getAction(this.url.list, params)
        .then(res => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    onDateChange: function(value, dateString) {
      this.queryParam.eventTime_begin = dateString[0]
      this.queryParam.eventTime_end = dateString[1]
      this.searchQuery()
    },
    dataLine(record) {
      const timeRange = [
        moment(record.eventTime)
          .add(-1, 'hours')
          .format('YYYY-MM-DD HH:mm'),
        moment(record.eventTime)
          .add(1, 'hours')
          .format('YYYY-MM-DD HH:mm')
      ]
      const pointCode = record.pointCode
      this.$refs.pointsDataLineModal.show(pointCode, timeRange)
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'datetime', value: 'eventTime', text: '事件时间' })
      fieldList.push({ type: 'string', value: 'pointCode', text: '事件测点', dictCode: '' })
      fieldList.push({ type: 'string', value: 'pointName', text: '事件测点名称', dictCode: '' })
      fieldList.push({ type: 'double', value: 'lastValue', text: '上次值', dictCode: '' })
      fieldList.push({ type: 'double', value: 'currentValue', text: '当前值', dictCode: '' })
      fieldList.push({ type: 'string', value: 'eventDesc', text: '事件说明', dictCode: '' })
      fieldList.push({
        type: 'list_multi',
        value: 'eventSource',
        text: '事件源头',
        dictTable: '',
        dictText: '',
        dictCode: ''
      })
      fieldList.push({ type: 'string', value: 'bak', text: 'bak', dictCode: '' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
